export default {
  mls: {
    'single family home': 'Single-Family Home',
    'condo': 'Condo',
    'multi family': 'Multi-Family',
    'apartment': 'Apartment',
    'townhouse': 'Townhouse',
    'duplex': 'Duplex',
    'co-op': 'Co-op',
    'trailer': 'Trailer',
    'manufactured': 'Manufactured',
    'other': 'Other'
  },
  internal: {
    'single family home': 'Single-Family Home',
    'condo': 'Condo',
    'apartment': 'Apartment',
    'townhouse': 'Townhouse',
    'duplex': 'Duplex',
  }
};